import { useState } from "react";
import Switch from "devextreme-react/switch";
import GridView from "./GridView";
import GraphView from "./GraphView";

export default (props) => {
  const {
    siteId,
    tierId,
    tabData,
    currenttab,
    tab,
    siteUid,
    isEditable,
    activeItem,
    widgetId,
    siteDate

  } = props;

  const [view, setView] = useState(false);

  return (
    <>
      {(!tierId || "") && (
        <div className="rail-switch">
          <Switch
            value={view}
            switchedOnText="Rail Grid View"
            switchedOffText="Graph View"
            width="100px"
            onValueChanged={() => setView(!view)}
          />
        </div>
      )}

      {!view && (
        <GridView
          siteId={siteId}
          tierId={tierId}
          tabData={tabData}
          currenttab={currenttab}
          tab={tab}
          siteUid={siteUid}
          isEditable={isEditable}
          activeItem={activeItem}
          widgetId={widgetId}
          siteDate={siteDate}
        />
      )}

      {view && (
        <GraphView
          siteId={siteId}
          tierId={tierId}
          tabData={tabData}
          currenttab={currenttab}
          tab={tab}
          siteUid={siteUid}
          isEditable={isEditable}
          activeItem={activeItem}
          widgetId={widgetId}
        />
      )}
    </>
  );
};
